class BaoProductGrid extends window.BAO.CustomElement() {
  setupListeners () {
    this.facetsWrapper = this.els?.facetsWrapper?.element
    this.stickyReference = this.els?.stickyReference?.element
    this.header = document.querySelector('.section-header')
    this.quickLinks = this.querySelector('.col-QuickLinks')
    this.desktopMediaQuery = window.matchMedia('(min-width: 768px)')

    if (!this.facetsWrapper || !this.stickyReference) return

    this.onScroll = this.onScroll.bind(this)
    this.onResize = this.onResize.bind(this)
    this.recalculateStickyThreshold = this.recalculateStickyThreshold.bind(this)
    this.updateQuickLinksFade = this.updateQuickLinksFade.bind(this)

    this.listeners.add(window, 'scroll', this.onScroll, { passive: true })
    this.listeners.add(window, 'resize', this.onResize, { passive: true })
    this.listeners.add(window, 'load', this.onResize)
    this.listeners.add(window, 'pageshow', this.onResize)

    if (this.quickLinks) {
      this.listeners.add(this.quickLinks, 'scroll', this.updateQuickLinksFade, {
        passive: true,
      })
    }

    if (this.desktopMediaQuery.addEventListener) {
      this.listeners.add(this.desktopMediaQuery, 'change', this.updateQuickLinksFade)
    } else if (this.desktopMediaQuery.addListener) {
      this.desktopMediaQuery.addListener(this.updateQuickLinksFade)
    }

    window.requestAnimationFrame(() => {
      this.recalculateStickyThreshold()
      this.updateStickyState()
      this.updateQuickLinksFade()
    })
  }

  onScroll () {
    if (this.isTicking) return

    this.isTicking = true

    window.requestAnimationFrame(() => {
      this.updateStickyState()
      this.isTicking = false
    })
  }

  onResize () {
    this.recalculateStickyThreshold()
    this.updateStickyState()
    this.updateQuickLinksFade()
  }

  updateQuickLinksFade () {
    if (!this.quickLinks) return

    const maxScroll = this.quickLinks.scrollWidth - this.quickLinks.clientWidth
    const hasOverflow = maxScroll > 1

    this.quickLinks.dataset.overflow = hasOverflow ? 'true' : 'false'
    this.quickLinks.dataset.atStart = this.quickLinks.scrollLeft <= 1 ? 'true' : 'false'
    this.quickLinks.dataset.atEnd =
      this.quickLinks.scrollLeft >= maxScroll - 1 ? 'true' : 'false'
  }

  getHeaderBottom () {
    if (!this.header) return 0

    return Math.max(0, Math.round(this.header.getBoundingClientRect().bottom))
  }

  syncStickyTop () {
    this.stickyTop = this.getHeaderBottom()
    this.facetsWrapper.style.top = `${this.stickyTop}px`
  }

  recalculateStickyThreshold () {
    if (!this.facetsWrapper || !this.stickyReference) return

    this.syncStickyTop()
    this.stickyStart = window.scrollY + this.stickyReference.getBoundingClientRect().top - this.stickyTop
  }

  updateStickyState () {
    if (!this.facetsWrapper) return

    if (typeof this.stickyStart !== 'number' || typeof this.stickyTop !== 'number') {
      this.recalculateStickyThreshold()
    }

    this.syncStickyTop()

    const wrapperTop = this.facetsWrapper.getBoundingClientRect().top
    const isSticky = window.scrollY >= this.stickyStart && wrapperTop <= this.stickyTop

    this.facetsWrapper.dataset.isSticky = isSticky ? 'true' : 'false'
  }
}

if (!customElements.get('bao-product-grid')) {
  customElements.define('bao-product-grid', BaoProductGrid)
}
